import classes from './ContactUs.module.scss';
import { useState } from 'react';
import useForm from './useForm';
import FormRedirect from '../../organisms/formRedirect/FormRedirect';
import areaCode from '../../../utils/data/countries.json';
import Image from 'next/image';
import Link from 'next/link';
import CustomSelect from '../../molecules/customSelect/CustomSelect';
import CustomTelCode from '../../molecules/customSelect/CustomTelCode';

export default function ContactUs({ ...data }) {
    const {
        handleChange,
        handleChangePhone,
        handleButton,
        isDisabled,
        inputsErrors,
        onSuccess,
        form
    } = useForm();
    const { city_region, icon_country, street_address } = data;
    const marketingList = data.marketing_list;
    const siteContent = data.ComponentContentSiteContent;
    const name = data.ComponentFieldEntryField[0];
    const email = data.ComponentFieldEntryField[1];
    const phone = data.ComponentFieldEntryField[3];
    const subject = data.ComponentFieldDropdownField;
    const message = data.ComponentFieldEntryField[2];
    const submit = data.ComponentButtonNav;
    const address = street_address.split('\n');

    const subjectList = subject.list?.options;

    const subjectDefault = data.DropdownPlaceholder.list?.options;
    const defaultCustomSelectValue = subjectDefault[0].selection;
    const [selectedDefault] = useState(defaultCustomSelectValue);

    const handlePhoneValidation = (e) => {
        if (e.target.value.length > e.target.maxLength) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
        }
        if (e.target.value.length <= e.target.minLength) {
            e.target.setCustomValidity('More than 8, less than 16 digits required');
        }
        if (e.target.value.length > e.target.minLength) {
            e.target.setCustomValidity('');
        }
    };

    return (
        <div className={classes.oContactSection}>
            <div className={`${classes.oContactWrapper} container`}>
                <div className={`row no-gutters`}>
                    <h1 className={`${classes.aBlockTitle} fntH1s fnt-b`}>
                        {siteContent.site_header}
                    </h1>
                </div>
                <div className={`row`}>
                    <div className={classes.oColDetails}>
                        <div className={classes.mPhysicalAddress}>
                            <div className={classes.mLocationWrapper}>
                                <figure className={classes.aIconLocation}>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
                                            fill="white"
                                            fillOpacity="0.4"
                                            stroke="white"
                                            strokeWidth="1.3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
                                            stroke="white"
                                            strokeWidth="1.3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </figure>
                                <p className={`${classes.aText} fnt18f`}>{icon_country}</p>
                            </div>
                            <h2 className={`${classes.aText} ${classes.city} fnt24f`}>
                                {city_region}
                            </h2>
                            <div
                                className={`${classes.aText} ${classes.physicalAddress} fnt16f`}
                                dangerouslySetInnerHTML={{ __html: address }}
                            ></div>
                        </div>
                        <hr className={classes.aContactHr} />
                        <div className={classes.oMarketingList}>
                            {marketingList.map((item) => (
                                <div className={classes.mContactLine} key={item.id}>
                                    <figure className={classes.aContactIcon}>
                                        <Image
                                            src={item.icon}
                                            alt={item.title}
                                            width={24}
                                            height={24}
                                            className={classes.aImage}
                                            layout="fixed"
                                        />
                                    </figure>
                                    <Link className={`${classes.aText} fnt16f`} href="">
                                        <a href={item.url} className={classes.aLinkText}>
                                            {item.title}
                                        </a>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={classes.oColForm}>
                        {onSuccess ? (
                            <FormRedirect ticketId={onSuccess} />
                        ) : (
                            <form
                                onSubmit={(e) => {
                                    handleButton(e);
                                }}
                                className={classes.contactForm}
                            >
                                <label className={classes.mInput}>
                                    <span className={`${classes.aText} fnt12f`}>
                                        {name.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <input
                                        className={`${classes.aInput} fnt16f`}
                                        type="text"
                                        name="name"
                                        pattern="[aA-zZ_ ]{0,100}"
                                        title="Please use alphabet characters only (A to Z)"
                                        value={form.name}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={name.placeholder}
                                    />

                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.name && name.error_message}
                                    </div>
                                </label>
                                <label className={classes.mInput}>
                                    <span className={`${classes.aText} fnt12f`}>
                                        {subject.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <CustomSelect
                                        handleSelect={handleChange}
                                        listOptions={subjectList}
                                        defaultValue={selectedDefault}
                                        {...data}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.subject && subject.error_message}
                                    </div>
                                </label>
                                <label className={classes.mInput}>
                                    <span className={`${classes.aText} fnt12f`}>
                                        {email.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <input
                                        className={`${classes.aInput} fnt16f`}
                                        type="email"
                                        name="email"
                                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,9}$"
                                        title="Valid email address required"
                                        value={form.email}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={email.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.email && email.error_message}
                                    </div>
                                </label>

                                <label className={`${classes.mInput} ${classes.telephone}`}>
                                    <span className={`${classes.aText} fnt12f`}>
                                        {phone.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <div className={classes.oWrapper}>
                                        <span
                                            className={`${classes.mWrapper} ${classes.mCountryCode}`}
                                        >
                                            <CustomTelCode
                                                handleSelect={handleChange}
                                                listOptions={areaCode}
                                                defaultValue={selectedDefault}
                                                {...data}
                                            />
                                        </span>
                                        <span className={`${classes.mWrapper} ${classes.mPhone}`}>
                                            <input
                                                className={`${classes.aInput} fnt16f`}
                                                type="number"
                                                name="phone"
                                                pattern="^[0-9][0-9]{8,16}$"
                                                onInput={(e) => handlePhoneValidation(e)}
                                                maxLength={15}
                                                minLength={8}
                                                title={`More than 8, less than 16 digits required`}
                                                value={form.phone}
                                                onChange={(e) => handleChangePhone(e)}
                                                placeholder={phone.placeholder}
                                                required
                                            />
                                        </span>
                                        <div
                                            className={`${classes.aError} ${classes.aText} fnt13f`}
                                        >
                                            {inputsErrors.phone && phone.error_message}
                                        </div>
                                    </div>
                                </label>

                                <label className={classes.mInput}>
                                    <span className={`${classes.aText} fnt12f`}>
                                        {message.title} <span className={classes.aRequired}>*</span>
                                    </span>
                                    <textarea
                                        className={`${classes.aInput} ${classes.messageText} fnt16f`}
                                        name="message"
                                        value={form.message}
                                        onChange={(e) => handleChange(e)}
                                        placeholder={message.placeholder}
                                    />
                                    <div className={`${classes.aError} ${classes.aText} fnt13f`}>
                                        {inputsErrors.message && message.error_message}
                                    </div>
                                </label>
                                <div
                                    className={`${classes.oCtaWrapper} ${
                                        classes[`${isDisabled && 'hideButton'}`]
                                    }`}
                                >
                                    <span
                                        className={`${classes.mBtn} ${
                                            classes[`${isDisabled && 'hideButton'}`]
                                        } ${classes.iconButton}`}
                                    >
                                        <figure className={classes.mIcon}>
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.66634 7.99976H13.333"
                                                    stroke="white"
                                                    strokeWidth="0.976562"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M8.00016 13.3334L13.3335 8.00008L8.00016 2.66675"
                                                    stroke="white"
                                                    strokeWidth="0.976562"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </figure>
                                        <span className={`${classes.aText} fnt18f`}>
                                            {submit.label}
                                        </span>
                                        <input
                                            type="submit"
                                            value={submit.label}
                                            className={classes.inputClick}
                                            disabled={isDisabled}
                                        />
                                    </span>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
